import { Module } from 'vuex'
import { state } from './state'
import { actions } from './actions'
import { getters } from './getters'
import { mutations } from './mutations'
import { RootState } from 'store'
import { DashboardState } from './types'

export const dashboard: Module<DashboardState, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}

